export const graphTooltipStyle = { fontSize: "1.6rem", color: "#000" };
